
import { mixins, Options } from 'vue-class-component';
import CartWidgetMixin from '@/mixins/cartWidget';
import LazyImage from './LazyImage.vue';

@Options({
  components: {
    LazyImage
  },
  props: {
    reward: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function,
      required: false
    },
    cta: {
      type: String,
      required: false
    },
    addingToCart: {
      type: Boolean,
      required: true
    },
    walletLimitReached: {
      type: Boolean,
      required: true
    }
  }
})
export default class MReward extends mixins(CartWidgetMixin) {
  reward: any;
  onClick: (reward: any) => void;
  cta: string;
  addingToCart: boolean;
  walletLimitReached: boolean;

  clickHandler(reward: Record<string, unknown>): void {
    // Record<string, unknown> is just an object type that is safe with the linter
    if (this.onClick) {
      this.onClick(reward);
    }
  }

  get delegateCashIcon() {
    return require('@/assets/images/delegate-cash-icon.png');
  }

  get brokenImageIcon() {
    return require('@/assets/images/broken-image-icon.png');
  }
}
